"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_QuestionnaireResponse = exports.QuestionnaireResponseStatusKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_canonical_1 = require("../Scalar/RTTI_canonical");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_QuestionnaireResponse_Item_1 = require("./RTTI_QuestionnaireResponse_Item");
var QuestionnaireResponseStatusKind;
(function (QuestionnaireResponseStatusKind) {
    QuestionnaireResponseStatusKind["_inProgress"] = "in-progress";
    QuestionnaireResponseStatusKind["_completed"] = "completed";
    QuestionnaireResponseStatusKind["_amended"] = "amended";
    QuestionnaireResponseStatusKind["_enteredInError"] = "entered-in-error";
    QuestionnaireResponseStatusKind["_stopped"] = "stopped";
})(QuestionnaireResponseStatusKind = exports.QuestionnaireResponseStatusKind || (exports.QuestionnaireResponseStatusKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_QuestionnaireResponse = t.recursion('IQuestionnaireResponse', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('QuestionnaireResponse')
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: RTTI_Identifier_1.RTTI_Identifier,
            basedOn: t.array(RTTI_Reference_1.RTTI_Reference),
            partOf: t.array(RTTI_Reference_1.RTTI_Reference),
            questionnaire: RTTI_canonical_1.RTTI_canonical,
            status: (0, EnumType_1.createEnumType)(QuestionnaireResponseStatusKind, 'QuestionnaireResponseStatusKind'),
            _status: RTTI_Element_1.RTTI_Element,
            subject: RTTI_Reference_1.RTTI_Reference,
            encounter: RTTI_Reference_1.RTTI_Reference,
            authored: RTTI_dateTime_1.RTTI_dateTime,
            _authored: RTTI_Element_1.RTTI_Element,
            author: RTTI_Reference_1.RTTI_Reference,
            source: RTTI_Reference_1.RTTI_Reference,
            item: t.array(RTTI_QuestionnaireResponse_Item_1.RTTI_QuestionnaireResponse_Item)
        })
    ]);
});
//# sourceMappingURL=RTTI_QuestionnaireResponse.js.map